import Sidebar from 'js/components-v2/pages/UserDashboard/Sidebar';
import AppContent from 'js/components/AppContent';
import AppState from 'js/stores/AppState';
import UserDashboardPageState from 'js/stores/pages/UserDashboardPageState';
import React from 'react';
import Content from '../Content';
import Transactions from './Transactions';

const TransactionsDashboardPage = () => {
  const page = UserDashboardPageState.create();

  React.useEffect(async () => {
    AppState.setCurrentPage('UserDashboardPage');

    await page.load();
  }, []);

  return (
    <AppContent className='user-dashboard d-lg-flex align-items-stretch'>
      <Sidebar currentPage='UserTransactionsPage' pageState={page} />
      <Content currentPage='UserTransactionsPage' showCards={false}>
        <Transactions />
      </Content>
    </AppContent>
  );
}

export default TransactionsDashboardPage;
